// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as Core__Array from "@rescript/core/src/Core__Array.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CardUtils$OrcaPaymentPage from "./CardUtils.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "./Utilities/JotaiAtoms.bs.js";
import * as PaymentUtils$OrcaPaymentPage from "./Utilities/PaymentUtils.bs.js";
import * as PaymentMethodCollectUtils$OrcaPaymentPage from "./Utilities/PaymentMethodCollectUtils.bs.js";

function FormViewJourney(props) {
  let journeyView = props.journeyView;
  let enabledPaymentMethodsWithDynamicFields = props.enabledPaymentMethodsWithDynamicFields;
  let handleSubmit = props.handleSubmit;
  let primaryTheme = props.primaryTheme;
  let match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  let localeString = match.localeString;
  let payoutDynamicFields = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.payoutDynamicFieldsAtom);
  let formData = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.formDataAtom);
  let match$1 = Jotai.useAtom(JotaiAtoms$OrcaPaymentPage.paymentMethodTypeAtom);
  let setActivePmt = match$1[1];
  let activePmt = match$1[0];
  let match$2 = Jotai.useAtom(JotaiAtoms$OrcaPaymentPage.validityDictAtom);
  let setValidityDict = match$2[1];
  let validityDict = match$2[0];
  let paymentMethodListValue = Jotai.useAtomValue(PaymentUtils$OrcaPaymentPage.paymentMethodListValue);
  let supportedCardBrands = React.useMemo(() => PaymentUtils$OrcaPaymentPage.getSupportedCardBrands(paymentMethodListValue), [paymentMethodListValue]);
  let match$3 = React.useState(() => false);
  let setFormSubmitted = match$3[1];
  let formSubmitted = match$3[0];
  let viewStack = React.useRef([journeyView]);
  let push = newState => {
    viewStack.current = Belt_Array.concatMany([
      viewStack.current,
      [newState]
    ]);
  };
  let pop = () => {
    let match = viewStack.current.length;
    if (match !== 0 && match !== 1) {
      viewStack.current.pop();
      return;
    }
  };
  let get = () => Core__Option.getOr(viewStack.current[viewStack.current.length - 1 | 0], journeyView);
  let match$4 = React.useState(() => get());
  let setStateView = match$4[1];
  let view = match$4[0];
  let popView = countOpt => {
    let count = countOpt !== undefined ? countOpt : 1;
    setStateView(param => {
      for (let _for = 1; _for <= count; ++_for) {
        pop();
      }
      return get();
    });
  };
  let renderInfoTemplate = (label, value, uniqueKey) => JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: label,
        className: "w-4/10 text-jp-gray-800 text-sm min-w-40 text-end"
      }),
      JsxRuntime.jsx("div", {
        children: "",
        className: "mx-2.5 h-4 w-0.5 bg-jp-gray-300"
      }),
      JsxRuntime.jsx("div", {
        children: value,
        className: "w-6/10 text-sm min-w-40"
      })
    ],
    className: "flex flex-row items-center"
  }, uniqueKey);
  let renderBackButton = () => JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx("button", {
      children: "←",
      className: "bg-jp-gray-600 rounded-full h-7 w-7 self-center mr-5",
      onClick: param => popView(undefined)
    }),
    className: "flex justify-center items-center"
  });
  let renderSaveButton = onClickHandler => JsxRuntime.jsx("button", {
    children: localeString.formSaveText,
    className: "min-w-full mt-10 text-lg font-semibold px-2.5 py-1.5 text-white rounded",
    style: {
      backgroundColor: primaryTheme
    },
    onClick: onClickHandler
  });
  let renderHeader = (title, shouldRenderBackButton) => JsxRuntime.jsxs("div", {
    children: [
      shouldRenderBackButton ? renderBackButton() : null,
      JsxRuntime.jsx("div", {
        children: title,
        className: "text-xl lg:text-3xl font-semibold"
      })
    ],
    className: "flex flex-row justify-start"
  });
  let contentSubHeaderClasses = "text-base text-gray-500";
  let tmp;
  if (typeof view !== "object") {
    tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        renderHeader(localeString.formHeaderSelectAccountText, false),
        JsxRuntime.jsx("div", {
          children: localeString.formFundsInfoText,
          className: contentSubHeaderClasses
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("div", {
            children: props.availablePaymentMethods.map((option, i) => JsxRuntime.jsxs("button", {
              children: [
                PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodIcon(option),
                JsxRuntime.jsx("label", {
                  children: String(option),
                  className: "text-start ml-2.5 cursor-pointer"
                })
              ],
              className: "flex flex-row items-center border border-solid border-jp-gray-200 px-5 py-2.5 rounded mt-2.5 hover:bg-jp-gray-50",
              onClick: param => {
                let view;
                if (option === "Card") {
                  let newPmt = {
                    TAG: "Card",
                    _0: "Debit"
                  };
                  let payoutDynamicFields = Core__Option.getOr(PaymentMethodCollectUtils$OrcaPaymentPage.getPayoutDynamicFields(enabledPaymentMethodsWithDynamicFields, newPmt), PaymentMethodCollectUtils$OrcaPaymentPage.defaultPayoutDynamicFields(newPmt));
                  setActivePmt(param => newPmt);
                  view = Core__Option.getOr(Core__Option.map(payoutDynamicFields.address, address => {
                    let fieldsToCollect = address.filter(addressField => addressField.value === undefined);
                    if (fieldsToCollect.length > 0) {
                      return {
                        TAG: "AddressForm",
                        _0: address
                      };
                    } else {
                      return {
                        TAG: "PMDForm",
                        _0: newPmt,
                        _1: payoutDynamicFields.payoutMethodData
                      };
                    }
                  }), {
                    TAG: "PMDForm",
                    _0: newPmt,
                    _1: payoutDynamicFields.payoutMethodData
                  });
                } else {
                  view = {
                    TAG: "SelectPMType",
                    _0: option
                  };
                }
                setStateView(param => {
                  push(view);
                  return view;
                });
              }
            }, i.toString())),
            className: "flex flex-col mt-2.5"
          }),
          className: "mt-2.5"
        })
      ]
    });
  } else {
    switch (view.TAG) {
      case "SelectPMType" :
        let selectedPm = view._0;
        let availablePmts = Core__Array.filterMap(props.availablePaymentMethodTypes, pmt => {
          switch (selectedPm) {
            case "Card" :
              return;
            case "BankRedirect" :
              if (pmt.TAG === "BankRedirect") {
                return {
                  TAG: "BankRedirect",
                  _0: pmt._0
                };
              } else {
                return;
              }
            case "BankTransfer" :
              if (pmt.TAG === "BankTransfer") {
                return {
                  TAG: "BankTransfer",
                  _0: pmt._0
                };
              } else {
                return;
              }
            case "Wallet" :
              if (pmt.TAG === "Wallet") {
                return {
                  TAG: "Wallet",
                  _0: pmt._0
                };
              } else {
                return;
              }
          }
        });
        let optionSelectionHandler = newPmt => {
          setActivePmt(param => newPmt);
          let payoutDynamicFields = Core__Option.getOr(PaymentMethodCollectUtils$OrcaPaymentPage.getPayoutDynamicFields(enabledPaymentMethodsWithDynamicFields, newPmt), PaymentMethodCollectUtils$OrcaPaymentPage.defaultPayoutDynamicFields(newPmt));
          let view = Core__Option.getOr(Core__Option.map(payoutDynamicFields.address, address => {
            let fieldsToCollect = address.filter(addressField => addressField.value === undefined);
            if (fieldsToCollect.length > 0) {
              return {
                TAG: "AddressForm",
                _0: address
              };
            } else {
              return {
                TAG: "PMDForm",
                _0: newPmt,
                _1: payoutDynamicFields.payoutMethodData
              };
            }
          }), {
            TAG: "PMDForm",
            _0: newPmt,
            _1: payoutDynamicFields.payoutMethodData
          });
          setStateView(param => {
            push(view);
            return view;
          });
        };
        if (selectedPm === "Card") {
          setStateView(param => {
            push("SelectPM");
            return "SelectPM";
          });
          tmp = null;
        } else {
          tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
            children: [
              renderHeader(localeString.formHeaderSelectBankText, true),
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx("div", {
                  children: availablePmts.map((option, i) => {
                    switch (option.TAG) {
                      case "Card" :
                        return null;
                      case "BankRedirect" :
                        let bankRedirect = option._0;
                        return JsxRuntime.jsxs("button", {
                          children: [
                            PaymentMethodCollectUtils$OrcaPaymentPage.getBankRedirectIcon(bankRedirect),
                            JsxRuntime.jsx("label", {
                              children: String(bankRedirect),
                              className: "text-start ml-2.5 cursor-pointer"
                            })
                          ],
                          className: "flex flex-row items-center border border-solid border-jp-gray-200 px-5 py-2.5 rounded mt-2.5 hover:bg-jp-gray-50",
                          onClick: param => optionSelectionHandler(option)
                        }, i.toString());
                      case "BankTransfer" :
                        let transfer = option._0;
                        return JsxRuntime.jsxs("button", {
                          children: [
                            PaymentMethodCollectUtils$OrcaPaymentPage.getBankTransferIcon(transfer),
                            JsxRuntime.jsx("label", {
                              children: String(transfer),
                              className: "text-start ml-2.5 cursor-pointer"
                            })
                          ],
                          className: "flex flex-row items-center border border-solid border-jp-gray-200 px-5 py-2.5 rounded mt-2.5 hover:bg-jp-gray-50",
                          onClick: param => optionSelectionHandler(option)
                        }, i.toString());
                      case "Wallet" :
                        let wallet = option._0;
                        return JsxRuntime.jsxs("button", {
                          children: [
                            PaymentMethodCollectUtils$OrcaPaymentPage.getWalletIcon(wallet),
                            JsxRuntime.jsx("label", {
                              children: String(wallet),
                              className: "text-start ml-2.5 cursor-pointer"
                            })
                          ],
                          className: "flex flex-row items-center border border-solid border-jp-gray-200 px-5 py-2.5 rounded mt-2.5 hover:bg-jp-gray-50",
                          onClick: param => optionSelectionHandler(option)
                        }, i.toString());
                    }
                  }),
                  className: "flex flex-col mt-2.5"
                }),
                className: "mt-2.5"
              })
            ]
          });
        }
        break;
      case "AddressForm" :
        let addressFields = view._0;
        let onSaveHandler = () => {
          let match = Core__Array.reduce(addressFields, [
            {},
            true
          ], (param, field) => {
            let fieldValidity = param[0];
            let key = PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldKey({
              TAG: "BillingAddress",
              _0: field.fieldType
            });
            let value = Core__Option.getOr(formData[key], "");
            let validity = PaymentMethodCollectUtils$OrcaPaymentPage.calculateValidity({
              TAG: "BillingAddress",
              _0: field.fieldType
            }, value, "", false);
            fieldValidity[key] = validity;
            return [
              fieldValidity,
              param[1] && Primitive_object.notequal(validity, false)
            ];
          });
          let fieldValidity = match[0];
          setValidityDict(param => fieldValidity);
          if (!match[1]) {
            return;
          }
          let view_1 = payoutDynamicFields.payoutMethodData;
          let view = {
            TAG: "PMDForm",
            _0: activePmt,
            _1: view_1
          };
          setStateView(param => {
            push(view);
            return view;
          });
        };
        tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            renderHeader(localeString.billingDetailsText, true),
            JsxRuntime.jsx("div", {
              children: localeString.formSubheaderBillingDetailsText,
              className: contentSubHeaderClasses
            }),
            JsxRuntime.jsxs("div", {
              children: [
                props.renderAddressForm(addressFields),
                renderSaveButton(param => onSaveHandler())
              ],
              className: "mt-2.5"
            })
          ]
        });
        break;
      case "PMDForm" :
        let pmdFields = view._1;
        let activePmt$1 = view._0;
        let pm = PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodForPmt(activePmt$1);
        let key = PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodTypeLabel(activePmt$1);
        let onSaveHandler$1 = () => {
          let match = Core__Array.reduce(pmdFields, [
            Object.assign({}, validityDict),
            true
          ], (param, field) => {
            let fieldValidity = param[0];
            let key = PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldKey({
              TAG: "PayoutMethodData",
              _0: field.fieldType
            });
            let value = Core__Option.getOr(formData[key], "");
            let validCardBrand = CardUtils$OrcaPaymentPage.getFirstValidCardSchemeFromPML(value, Core__Option.getOr(supportedCardBrands, []));
            let newCardBrand = validCardBrand !== undefined ? validCardBrand : CardUtils$OrcaPaymentPage.getCardBrand(value);
            let validity = PaymentMethodCollectUtils$OrcaPaymentPage.calculateValidity({
              TAG: "PayoutMethodData",
              _0: field.fieldType
            }, value, newCardBrand, false);
            fieldValidity[key] = validity;
            return [
              fieldValidity,
              param[1] && Primitive_object.notequal(validity, false)
            ];
          });
          let fieldValidity = match[0];
          setValidityDict(param => fieldValidity);
          if (match[1]) {
            Core__Option.map(PaymentMethodCollectUtils$OrcaPaymentPage.formPaymentMethodData(formData, fieldValidity, payoutDynamicFields), pmd => {
              let view = {
                TAG: "FinalizeView",
                _0: [
                  activePmt$1,
                  pmd
                ]
              };
              setStateView(param => {
                push(view);
                return view;
              });
            });
            return;
          }
        };
        let tmp$1;
        switch (pm) {
          case "Card" :
            tmp$1 = localeString.formHeaderEnterCardText;
            break;
          case "BankRedirect" :
          case "BankTransfer" :
            tmp$1 = localeString.formHeaderBankText(key);
            break;
          case "Wallet" :
            tmp$1 = localeString.formHeaderWalletText(key);
            break;
        }
        tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            renderHeader(tmp$1, true),
            JsxRuntime.jsxs("div", {
              children: [
                props.renderPayoutMethodForm(pmdFields),
                renderSaveButton(param => onSaveHandler$1())
              ],
              className: "mt-2.5"
            })
          ]
        });
        break;
      case "FinalizeView" :
        let match$5 = view._0;
        let formFields = match$5[1];
        let pmt = match$5[0];
        let pm$1 = PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodForPmt(pmt);
        tmp = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("img", {
                      className: "h-6 w-auto",
                      alt: "",
                      src: "merchantLogo"
                    }),
                    JsxRuntime.jsx("div", {
                      children: localeString.formHeaderReviewTabLayoutText(PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodTypeLabel(pmt)),
                      className: "ml-1.5"
                    })
                  ],
                  className: "flex flex-row items-center mb-2.5 text-xl font-semibold"
                }),
                formFields.map((field, i) => {
                  let value = field[1];
                  let field$1 = field[0];
                  if (field$1.TAG === "BillingAddress") {
                    return null;
                  }
                  let fieldType = field$1._0.fieldType;
                  if (typeof fieldType !== "object") {
                    return renderInfoTemplate(PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldLabel({
                      TAG: "PayoutMethodData",
                      _0: fieldType
                    }, localeString), value, i.toString());
                  }
                  if (fieldType._0 !== "CardExpMonth") {
                    return null;
                  }
                  let expiryYear = Core__Option.getOr(Core__Option.flatMap(formData[PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldKey({
                        TAG: "PayoutMethodData",
                        _0: {
                          TAG: "CardExpDate",
                          _0: "CardExpYear"
                        }
                      })], value => Core__Option.map(value.split("/")[1], year => `20` + year.trim())), "");
                  let expiryValue = value + ` / ` + expiryYear;
                  return renderInfoTemplate(PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldLabel({
                    TAG: "PayoutMethodData",
                    _0: {
                      TAG: "CardExpDate",
                      _0: "CardExpMonth"
                    }
                  }, localeString), expiryValue, i.toString());
                })
              ],
              className: "flex flex-col"
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("img", {
                  className: "h-3 w-auto mr-1.5",
                  alt: "",
                  src: "merchantLogo"
                }),
                localeString.formFundsCreditInfoText(PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodLabel(pm$1).toLowerCase())
              ],
              className: "flex flex-row items-center min-w-full my-5 px-2.5 py-1.5 text-xs border border-solid border-blue-200 rounded bg-blue-50"
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("button", {
                  children: localeString.formEditText,
                  className: "w-full px-2.5 py-1.5 rounded border border-solid",
                  style: {
                    borderColor: primaryTheme,
                    color: primaryTheme
                  },
                  disabled: formSubmitted,
                  onClick: param => popView(viewStack.current.length - 2 | 0)
                }),
                JsxRuntime.jsx("button", {
                  children: formSubmitted ? localeString.formSubmittingText : localeString.formSubmitText,
                  className: "w-full px-2.5 py-1.5 text-white rounded ml-2.5",
                  style: {
                    backgroundColor: primaryTheme
                  },
                  disabled: formSubmitted,
                  onClick: param => {
                    setFormSubmitted(param => true);
                    handleSubmit([
                      pmt,
                      formFields
                    ]);
                  }
                })
              ],
              className: "flex my-5 text-lg font-semibold w-full"
            })
          ]
        });
        break;
    }
  }
  return JsxRuntime.jsx("div", {
    children: tmp,
    className: "w-full max-w-[520px]"
  });
}

let make = FormViewJourney;

let $$default = FormViewJourney;

export {
  make,
  $$default as default,
}
/* jotai Not a pure module */
